import { render, staticRenderFns } from "./RemoveCourseDialog.vue?vue&type=template&id=4713f0d8&scoped=true&"
import script from "./RemoveCourseDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveCourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemoveCourseDialog.vue?vue&type=style&index=0&id=4713f0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713f0d8",
  null
  
)

export default component.exports